import PageHeader from 'src/components/page-header/page-header';
import css from './custom-page.module.scss';
import { useLocation, useParams } from 'react-router-dom';
import { useGetPage } from './data/queries';
import { CustomPageBlock } from 'src/types';
import CustomPageServices from './page-services';
import CustomPageEvents from './events/page-events';
import CustomPageContacts from './page-contacts';
import CustomPageTextBlock from './text-block/text-block';
import { PageEntityType } from 'src/types/custom-page/custom-page';
import CustomPagePartners from './page-partners';
import CustomPageVacancies from './page-vacancies';
import CustomBanner from './text-block/custom-banner';

export default function CustomPage() {
  const { slug } = useParams();
  const state = useLocation()?.state;

  const { data: page, isPending } = useGetPage(slug);

  const pages = [{ path: `/pages/${slug}`, title: page?.title }];

  const renderContent = (block: CustomPageBlock) => {
    switch (block.type) {
      case PageEntityType.Partners:
        return (
          <CustomPagePartners
            key={block.id}
            items={block.partners}
            title={block.title}
            description={block.description}
            type={block.type}
          />
        );
      case PageEntityType.Service:
        return (
          <CustomPageServices
            key={block.id}
            items={block.services}
            title={block.title}
            description={block.description}
            type={block.type}
            pages={pages}
          />
        );
      case PageEntityType.Event:
        return (
          <CustomPageEvents
            key={block.id}
            items={block.events}
            title={block.title}
            description={block.description}
            type={block.type}
            pages={pages}
          />
        );
      case PageEntityType.Vacancy:
        return (
          <CustomPageVacancies
            key={block.id}
            items={block.vacancies}
            title={block.title}
            description={block.description}
            type={block.type}
          />
        );
      case PageEntityType.ContactCard:
        return (
          <CustomPageContacts
            key={block.id}
            items={block.contacts}
            title={block.title}
            description={block.description}
            type={block.type}
          />
        );
      case PageEntityType.Banner:
        return <CustomBanner key={block.id} item={block} />;
      case PageEntityType.TextBlock:
        return <CustomPageTextBlock key={block.id} item={block} />;
      default:
        return null;
    }
  };

  return (
    <main className={css.customPage}>
      <PageHeader title={page?.title ?? ''} description={page?.description ?? ''} pages={state?.pages ?? []} />
      <div className={css.container}>
        {!page && !isPending && <h1 className={css.emptyPlaceholder}>Сторінка не знайдена</h1>}
        {page?.blocks.map((b: CustomPageBlock) => renderContent(b))}
      </div>
    </main>
  );
}
